var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('sba-navbar',{attrs:{"views":_vm.mainViews,"applications":_vm.applications,"error":_vm.error}}),_vm._v(" "),_c('router-view',{attrs:{"views":_vm.childViews,"applications":_vm.applications,"error":_vm.error}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0937cd2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/shell/index.vue
// module id = null
// module chunks = 